// src/pages/BlogPost.js
import { useParams } from 'react-router-dom';
import { posts } from '../data/posts';

const BlogPost = () => {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);

  if (!post) return <h2>Post not found</h2>;

  return (
    <div>
      <h1>{post.title}</h1>
      {post.content}
      
    </div>
  );
};

export default BlogPost;
